import { StationFilter } from "./station";

export interface UserReport {
    reportId: string;
    category: string;
    details?: string;
    section?: string;
    context?: {
        startStationId?: string,
        startStationFilters?: StationFilter
        endStationId?: string,
        endStationFilters?: StationFilter,
        bikeId?: string,
        tariffPlanId?: string,
        rideData?: any,
        userPosition?: {
            lat: number,
            lng: number
        },
        bikePosition?: {
            lat: number,
            lng: number
        }
    };
    userId: string;
    userIdDetails?: any;
    creationTimestamp: Date;
}

export interface UserReportFilter {
    options: {
        // section: string
    },
    cache: {
        // section: string
    },
    values: {
        // section?: string | undefined
    },
    applied: {
        // section?: string
    }
}


export function getDefaultUserReport(): UserReport {
    return structuredClone({
        reportId: '',
        category: '',
        userId: '',
        creationTimestamp: new Date()
    })
}